// src/belediye/components/ui/YeniOzellikBalonu.js
//
// Bir düğmenin üstüne oturan "YENİ" işareti.
//
// KULLANIM: hedef düğmeyi children olarak sar. Balon, sarmalayıcıya göre
// MUTLAK konumlanır; düğmenin kendi yerleşimi (flex, grid, başlık şeridi…)
// değişmez — sarmalayıcı `display: contents` DEĞİL, `inline-flex`tir çünkü
// mutlak katmanın bir konum bağlamına ihtiyacı var.
//
// AÇIKLAMA METNİ YOK (kullanıcı kararı): rozet + iki kelimelik ad yeterli.
// Uzun açıklama okunmuyor, yer kaplıyor ve düğmenin kendi title'ında zaten
// var. Bu yüzden kapatma düğmesi de yok — balon birkaç saniye sonra
// kendiliğinden kaybolur (süreyi hook yönetir).

import "./YeniOzellikBalonu.css";

export default function YeniOzellikBalonu({ gorunur, baslik = "Yeni", children }) {
  return (
    <span className={`yeni-ozellik${gorunur ? " yeni-ozellik--acik" : ""}`}>
      {children}

      {gorunur && (
        <span className="yeni-ozellik-balon" role="status">
          <span className="yeni-ozellik-ok" aria-hidden="true" />
          <span className="yeni-ozellik-rozet">YENİ</span>
          <span className="yeni-ozellik-baslik">{baslik}</span>
        </span>
      )}
    </span>
  );
}
